import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  container: {
    base: {
      borderRadius: theme.settings.borderRadiuses.regular,
      marginBottom: theme.settings.spacing.large,
      flex: 1,
    },

    flush: {
      marginBottom: 0,
    },

    variants: {
      primary: {
        backgroundColor: theme.colors.backgrounds.primary,
        borderColor: theme.colors.accents.primaryBorder,
      },

      alert: {
        backgroundColor: theme.colors.backgrounds.alert,
        borderColor: theme.colors.accents.alertBorder,
      },

      negative: {
        backgroundColor: theme.colors.backgrounds.negative,
        borderColor: theme.colors.accents.negativeBorder,
      },

      clear: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
      },
    },

    bordered: {
      borderWidth: '1px',
      borderStyle: 'solid',
    },

    padded: {
      padding: theme.settings.spacing.large,
    },
  },

  content: {
    base: {
      ...theme.typography.body,
      color: theme.colors.text.normal,
      marginBottom: theme.settings.spacing.large,
      display: 'flex',
    },

    last: {
      marginBottom: 0,
    },
  },

  icon: {
    base: {
      minWidth: '20px',
      width: '20px',
      marginRight: theme.settings.spacing.large,
    },
  },
})
